/* tslint:disable */
import {
  ServiceCharterGrouping
} from '../index';

declare var Object: any;
export interface ServiceCharterGroupInterface {
  "name"?: string;
  "lead_time"?: string;
  "description": string;
  "pricing"?: number;
  "paid"?: boolean;
  "group_id"?: number;
  "id"?: number;
  group?: ServiceCharterGrouping;
}

export class ServiceCharterGroup implements ServiceCharterGroupInterface {
  "name": string;
  "lead_time": string;
  "description": string;
  "pricing": number;
  "paid": boolean;
  "group_id": number;
  "id": number;
  group: ServiceCharterGrouping;
  constructor(data?: ServiceCharterGroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ServiceCharterGroup`.
   */
  public static getModelName() {
    return "ServiceCharterGroup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ServiceCharterGroup for dynamic purposes.
  **/
  public static factory(data: ServiceCharterGroupInterface): ServiceCharterGroup{
    return new ServiceCharterGroup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ServiceCharterGroup',
      plural: 'ServiceCharterGroups',
      path: 'ServiceCharterGroups',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "lead_time": {
          name: 'lead_time',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "pricing": {
          name: 'pricing',
          type: 'number'
        },
        "paid": {
          name: 'paid',
          type: 'boolean'
        },
        "group_id": {
          name: 'group_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        group: {
          name: 'group',
          type: 'ServiceCharterGrouping',
          model: 'ServiceCharterGrouping'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/ServiceCharterGroup.ts